import { render, staticRenderFns } from "./ForfunStats.vue?vue&type=template&id=791a643f&scoped=true&"
import script from "./ForfunStats.vue?vue&type=script&lang=js&"
export * from "./ForfunStats.vue?vue&type=script&lang=js&"
import style0 from "./ForfunStats.vue?vue&type=style&index=0&id=791a643f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791a643f",
  null
  
)

component.options.__file = "ForfunStats.vue"
export default component.exports